import {createUseStyles} from 'react-jss';
import {Theme} from '../themes/default';

const usePhotoStyles = createUseStyles((theme: Theme) => {
    return {
        container: {
            backgroundColor: theme.colors.espresso_brown,
            fontFamily: theme.fonts.apex,
            minHeight: '100vh',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            padding: theme.spacing(4),
            color: theme.palette.primary.light,
            position: 'relative',
        },
        titleSection: {
            textAlign: 'center',
            marginBottom: theme.spacing(6),
            maxWidth: '1000px',
            marginTop: theme.spacing(5),
            [theme.breakpoints.down('lg')]: {
                marginTop: 0,
            },
        },
        mainTitle: {
            fontFamily: theme.fonts.poplar,
            fontSize: '4.5rem',
            color: theme.palette.primary.light,
            margin: 0,
            lineHeight: 1.1,
            textShadow: '2px 2px 4px rgba(0,0,0,0.3)',
            letterSpacing: '2px',
            [theme.breakpoints.down('md')]: {
                fontSize: '3rem',
            },
            [theme.breakpoints.down('sm')]: {
                fontSize: '2.2rem',
            },
        },
        goldText: {
            color: theme.colors.desert_sand_gold,
        },
        photoGrid: {
            display: 'grid',
            gridTemplateColumns: 'repeat(5, 1fr)',
            gridTemplateRows: 'repeat(2, 1fr)',
            gap: theme.spacing(2),
            width: '100%',
            maxWidth: '1200px',
            height: '500px',
            [theme.breakpoints.down('lg')]: {
                gridTemplateColumns: 'repeat(4, 1fr)',
                gridTemplateRows: 'repeat(3, 1fr)',
                height: '600px',
            },
            [theme.breakpoints.down('md')]: {
                gridTemplateColumns: 'repeat(3, 1fr)',
                gridTemplateRows: 'repeat(4, 1fr)',
                height: '700px',
            },
            [theme.breakpoints.down('sm')]: {
                gridTemplateColumns: 'repeat(2, 1fr)',
                gridTemplateRows: 'repeat(5, 1fr)',
                gap: theme.spacing(1),
                height: '800px',
            },
        },
        photoItem: {
            position: 'relative',
            borderRadius: '12px',
            overflow: 'hidden',
            transition: 'transform 0.3s ease, box-shadow 0.3s ease',
            cursor: 'pointer',
            width: '100%',
            height: '100%',
            '&:hover': {
                transform: 'scale(1.02)',
                boxShadow: `0 8px 25px rgba(${theme.colors.desert_sand_gold.replace('#', '')}, 0.3)`,
            },
        },
        photoImage: {
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            display: 'block',
        },
        photoOverlay: {
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: 'linear-gradient(45deg, rgba(0,0,0,0.1) 0%, rgba(0,0,0,0.3) 100%)',
            opacity: 0,
            transition: 'opacity 0.3s ease',
            '$photoItem:hover &': {
                opacity: 1,
            },
        },
        // Lightbox Styles
        modal: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 2000,
        },
        lightboxContainer: {
            position: 'relative',
            maxWidth: '90vw',
            maxHeight: '90vh',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            outline: 'none',
        },
        lightboxImage: {
            maxWidth: '100%',
            maxHeight: '100%',
            objectFit: 'contain',
            borderRadius: '12px',
            boxShadow: '0 20px 60px rgba(0, 0, 0, 0.8)',
        },
        closeButton: {
            position: 'absolute',
            top: '20px',
            right: '20px',
            backgroundColor: 'transparent',
            color: theme.colors.ivory_beige,
            width: '50px',
            height: '50px',
            zIndex: 2001,
            transition: 'all 0.3s ease',
            backdropFilter: 'blur(10px)',
            border: `2px solid rgba(255, 255, 255, 0.3)`,
            '&:hover': {
                backgroundColor: 'rgba(255, 255, 255, 0.2)',
                color: theme.colors.golden_mustard,
                transform: 'scale(1.1)',
            },
            [theme.breakpoints.down('md')]: {
                width: '45px',
                height: '45px',
                top: '15px',
                right: '15px',
            },
        },
        navButton: {
            position: 'absolute',
            backgroundColor: 'transparent',
            color: theme.colors.ivory_beige,
            width: '60px',
            height: '60px',
            zIndex: 2001,
            transition: 'all 0.3s ease',
            backdropFilter: 'blur(10px)',
            border: `2px solid rgba(255, 255, 255, 0.3)`,
            top: '50%',
            transform: 'translateY(-50%)',
            '&:hover': {
                backgroundColor: 'rgba(255, 255, 255, 0.2)',
                color: theme.colors.golden_mustard,
                transform: 'translateY(-50%) scale(1.1)',
            },
            [theme.breakpoints.down('md')]: {
                width: '50px',
                height: '50px',
            },
        },
        prevButton: {
            left: '20px',
            [theme.breakpoints.down('md')]: {
                left: '15px',
            },
            [theme.breakpoints.down('sm')]: {
                left: '10px',
            },
        },
        nextButton: {
            right: '20px',
            [theme.breakpoints.down('md')]: {
                right: '15px',
            },
            [theme.breakpoints.down('sm')]: {
                right: '10px',
            },
        },
        imageCounter: {
            position: 'absolute',
            bottom: '-50px',
            left: '50%',
            transform: 'translateX(-50%)',
            backgroundColor: 'rgba(0, 0, 0, 0.8)',
            color: theme.colors.ivory_beige,
            padding: `${theme.spacing(1)} ${theme.spacing(2)}`,
            borderRadius: '20px',
            fontFamily: theme.fonts.apex,
            fontSize: '1rem',
            fontWeight: 600,
        },
    };
});

export default usePhotoStyles;